module.exports = __webpack_public_path__ + "img/texture_dark_2.434f048f.jpg";